"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _HTTPValidationError = _interopRequireDefault(require("../model/HTTPValidationError"));
var _News = _interopRequireDefault(require("../model/News"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
* News service.
* @module api/NewsApi
* @version 0.0.1
*/
class NewsApi {
  /**
  * Constructs a new NewsApi. 
  * @alias module:api/NewsApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  constructor(apiClient) {
    this.apiClient = apiClient || _ApiClient.default.instance;
  }

  /**
   * Callback function to receive the result of the getNewsNewsGet operation.
   * @callback module:api/NewsApi~getNewsNewsGetCallback
   * @param {String} error Error message, if any.
   * @param {Array.<module:model/News>} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Get News
   * @param {Object} opts Optional parameters
   * @param {String} [typ = 'kfv')] Typ der Nachrichten. Entweder 'kfv' oder 'kjf'
   * @param {module:api/NewsApi~getNewsNewsGetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Array.<module:model/News>}
   */
  getNewsNewsGet(opts, callback) {
    opts = opts || {};
    let postBody = null;
    let pathParams = {};
    let queryParams = {
      'typ': opts['typ']
    };
    let headerParams = {};
    let formParams = {};
    let authNames = [];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = [_News.default];
    return this.apiClient.callApi('/news/', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }
}
exports.default = NewsApi;